import logo from "../images/logo.png";

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-amber-700 to-amber-800 text-white py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src={logo}
                alt="Kadernícky salón Katka logo"
                className="h-12 w-12 object-contain"
              />
              <h3 className="text-xl font-semibold">Kadernícky salón Katka</h3>
            </div>
            <p className="text-amber-100 leading-relaxed">
              Profesionálne kadernícke služby s individuálnym prístupom. Vytvárame krásu s láskou k detailu.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Rýchle odkazy</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection("sluzby")}
                  className="text-amber-100 hover:text-white transition-colors cursor-pointer"
                >
                  Služby
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("galeria")}
                  className="text-amber-100 hover:text-white transition-colors cursor-pointer"
                >
                  Galéria
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("o-nas")}
                  className="text-amber-100 hover:text-white transition-colors cursor-pointer"
                >
                  O nás
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("kontakt")}
                  className="text-amber-100 hover:text-white transition-colors cursor-pointer"
                >
                  Kontakt
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Kontakt</h4>
            <ul className="space-y-3 text-amber-100">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <a href="tel:+421908942533" className="hover:text-white transition-colors">
                  +421 908 942 533
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <a
                  href="mailto:info@kadernickysalonkatka.sk"
                  className="hover:text-white transition-colors"
                >
                  info@kadernickysalonkatka.sk
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-1"></i>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Kollárova+55+Martin+Slovakia"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Kollárova 55, Martin, Slovakia
                </a>
              </li>

            </ul>
          </div>
        </div>

        <div className="border-t border-amber-600 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-amber-100 text-sm">© 2025 Kadernícky salón Katka. Všetky práva vyhradené.</p>


        </div>
      </div>
    </footer>
  );
}
